@if (alerts) { @for(item of alerts; track item){
<vy-alert-banner
  [type]="item.alertType"
  [alertContent]="item.message"
  [hasCloseButton]="false"
  [ngClass]="item.alertType"
>
</vy-alert-banner>
} }
